import { checkFormInputValidation } from 'components/common/func';
import { checkMaintenance } from 'helpers/maintenance';
import useCommonStore from 'hooks/useCommonStore';
import { isEmpty } from 'lodash';

const MAX_FILE_SIZE_MB = 4;
const FILE_IMAGE_EXT = ['heic', 'aae', 'heif'];
const FILE_IMAGE_TYPE = ['image/png', 'image/jpg', 'image/jpeg'];
const FILE_DOCUMENT_TYPE = ['application/pdf'];
export const FILE_ACCEPT = [...FILE_IMAGE_TYPE, ...FILE_DOCUMENT_TYPE];

const useFormInputUploadDocumentsFileTakePhoto = () => {
  const { setLoading } = useCommonStore();

  const PDFJS = window?.pdfjsLib;

  const convertFileSizeToMB = (size) => {
    return (size / (1024 * 1024)).toFixed(2);
  };

  const convertFileHEICToFileJPG = async (file, objectUrl) => {
    const fileName = file?.name?.split('.')[0];

    return heic2any({
      blob: file,
      toType: 'image/jpg',
    })
      .then(function (blob) {
        objectUrl = URL.createObjectURL(blob);

        file = new File([blob], fileName + '.jpg', {
          type: 'image/jpg',
          lastModified: new Date().getTime(),
        });

        return [file, objectUrl];
      })
      .catch(function (error) {
        console.error(error?.message);

        return [file, objectUrl];
      });
  };

  const fileImageTypeProcess = async (file, objectUrl) => {
    const { type } = file;

    if (FILE_IMAGE_TYPE.includes(type)) {
      const img = new Image();
      img.onload = function getDimension() {
        const { width, height } = img;
        file.width = width;
        file.height = height;
      };
    }

    return objectUrl;
  };

  const filePDFTypeProcess = async (field, file, objectUrl) => {
    const { type } = file;

    if (FILE_DOCUMENT_TYPE.includes(type)) {
      if (isEmpty(PDFJS)) return;
      const pdf = await PDFJS.getDocument({ url: objectUrl });
      const page = await pdf.getPage(1);
      const viewport = page.getViewport(1);

      const canvas = document.getElementById(`pdf-canvas-${field.name}`);
      canvas.setAttribute('width', viewport.width);
      canvas.setAttribute('height', viewport.height);
      const renderContext = {
        canvasContext: canvas.getContext('2d'),
        viewport,
      };
      await page.render(renderContext);

      const base64Data = canvas.toDataURL('image/png');
      const img = document.getElementsByName(field.name)[0];
      img.setAttribute('src', base64Data);
      img.setAttribute('width', viewport.width);
      img.setAttribute('height', viewport.height);

      const base64Response = await fetch(base64Data);
      const blob = await base64Response.blob();

      return URL.createObjectURL(blob);
    }

    return objectUrl;
  };

  const isFileImageExtAccept = (file) => {
    const fileExt = file?.name?.split('.')[1];

    return FILE_IMAGE_EXT.includes(fileExt?.toLowerCase());
  };

  const getUploadDocumentsFileTakePhoto = async ({
    e,
    field,
    information,
    setInformation,
    validation,
    setValidation,
  }) => {
    if (isEmpty(e)) {
      console.error(
        `🔥 useFormInputUploadDocumentsFileTakePhoto ❌ getUploadDocumentsFileTakePhoto ➡️ e is empty ↩`,
        e
      );
      return;
    }
    setLoading(true);
    try {
      let newInformation = { ...information };
      let newValidation = { ...validation };
      const { name, idType, docType } = field || {};
      const URL = window.URL || window.webkitURL;
      let fileData = e.target?.files[0];
      let objectUrl = URL?.createObjectURL(fileData);

      const fileSizeMB = convertFileSizeToMB(fileData.size);
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        newValidation = {
          ...newValidation,
          [name]: field?.msgSizeLimit,
        };
        setValidation(newValidation);
        return;
      }

      const isFileAccept = FILE_ACCEPT.includes(fileData.type);
      if (!isFileAccept && !isFileImageExtAccept(fileData)) {
        newValidation = {
          ...newValidation,
          [name]: field?.msgTypeAccept,
        };
        setValidation(newValidation);
        return;
      }

      if (isFileImageExtAccept(fileData)) {
        [fileData, objectUrl] = await convertFileHEICToFileJPG(
          fileData,
          objectUrl
        );
      }

      if (isEmpty(objectUrl)) {
        console.error(
          `🔥 useFormInputUploadDocumentsFileTakePhoto ❌ getUploadDocumentsFileTakePhoto ➡️ objectUrl is empty ↩`
        );
        return;
      }
      objectUrl = await fileImageTypeProcess(fileData, objectUrl);
      objectUrl = await filePDFTypeProcess(field, fileData, objectUrl);

      newValidation = checkFormInputValidation(objectUrl, field, validation);

      const fileObj = {
        file: fileData,
        path: objectUrl,
      };
      newInformation = {
        ...information,
        [name]: fileObj,
      };
      console.log(
        `⭐ useFormInputUploadDocumentsFileTakePhoto 👉 getUploadDocumentsFileTakePhoto ➡️ newInformation ↩`,
        newInformation
      );
      setInformation(newInformation);

      newValidation = checkFormInputValidation(
        newInformation[name],
        field,
        newValidation
      );
      console.log(
        `⭐ useFormInputUploadDocumentsFileTakePhoto 👉 getUploadDocumentsFileTakePhoto ➡️ newValidation ↩`,
        newValidation
      );
      setValidation(newValidation);
    } catch (error) {
      console.error(
        `🔥 useFormInputUploadDocumentsFileTakePhoto ❌ getUploadDocumentsFileTakePhoto ➡️ ERROR ↩`,
        error?.message
      );
      checkMaintenance(error);
    } finally {
      setLoading(false);
    }
  };

  return { getUploadDocumentsFileTakePhoto };
};

export default useFormInputUploadDocumentsFileTakePhoto;
